import { Controller } from "@hotwired/stimulus"

// Mobile sidebar drawer: toggles the sidebar and its backdrop below the lg breakpoint.
export default class extends Controller {
  static targets = ["sidebar", "backdrop"]

  open()  { this.sidebarTarget.dataset.open = "true";  this.backdropTarget.hidden = false }
  close() { delete this.sidebarTarget.dataset.open;    this.backdropTarget.hidden = true }
  toggle() { this.sidebarTarget.dataset.open ? this.close() : this.open() }
}
